export interface ISplash {
    title: string;
    imgUrl: string;
    message: string;
}
